import '../styles/Primitives.scss';
import { mergeSx } from '../_internal/styleProps';

export default function Paper({ children, className = '', component: Component = 'div', elevation, style, sx, variant, ...props }) {
  return <Component className={`ui-paper ${variant === 'outlined' ? 'ui-paper--outlined' : ''} ${className}`.trim()} style={mergeSx(sx, style)} {...props}>{children}</Component>;
}
